import React from 'react';
import ParticipantRow from './ParticipantRow';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';


const ParticipantList = ({ 
  participants, 
  onNameChange,
  onLocationChange, 
  onTransportChange, 
  onRemove, 
  onAdd,
  onUseCurrentLocation,
  onValidationChange,
  errors 
}) => {
  const canRemove = participants?.length > 2;

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground">
            Meeting Participants
          </h2>
          <p className="text-sm md:text-base text-muted-foreground mt-1">
            Add all participants who will attend the meeting
          </p>
        </div>
        <div className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 rounded-lg">
          <span className="font-heading font-semibold text-primary text-lg">
            {participants?.length}
          </span>
          <span className="caption text-muted-foreground">
            {participants?.length === 1 ? 'person' : 'people'}
          </span>
        </div>
      </div>
      <div className="space-y-4">
        {participants?.map((participant, index) => (
          <ParticipantRow
            key={participant?.id}
            participant={participant}
            index={index}
            onNameChange={onNameChange}
            onLocationChange={onLocationChange}
            onTransportChange={onTransportChange}
            onRemove={() => onRemove(index)}
            onUseCurrentLocation={onUseCurrentLocation}
            onValidationChange={onValidationChange}
            canRemove={canRemove}
            nameError={errors?.[index]?.name}
            locationError={errors?.[index]?.location}
            transportError={errors?.[index]?.transport}
          />
        ))}
      </div>
      <Button
        variant="outline"
        onClick={onAdd}
        iconName="Plus"
        iconPosition="left"
        fullWidth
        className="border-dashed"
      >
        Add Another Participant
      </Button>
      {participants?.length >= 10 && (
        <div className="flex items-start gap-3 p-4 bg-warning/10 border border-warning/20 rounded-lg">
          <Icon name="AlertCircle" size={20} className="text-warning flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-medium text-warning text-sm">
              Maximum participants reached
            </p>
            <p className="caption text-muted-foreground mt-1">
              For optimal results, we recommend limiting to 10 participants
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ParticipantList;